module.exports = __webpack_public_path__ + "img/1.a652adb6.jpg";